export const API_PATH_ApiTrafficStudyArchive = '/services/traffic-studies/apiTrafficStudyArchive';
